import makeFailSafe from '../libs/make-fail-safe';

const KEY = '_directive_analytics';

const setup = (el, binding) => {
  if (!window.ga) {
    throw new Error('window.ga is missing');
  }

  const options = binding.value;
  const handler = (e) => {
    const options = el[KEY].options;

    if (options === false) {
      return;
    }

    if (el.tagName === 'A' && el.href && el.target !== '_blank' && !e.defaultPrevented) {
      e.preventDefault();

      const pageMove = () => {
        const windows = {
          _self  : window,
          _parent: window.parent,
          _top   : window.top,
        };
        const targetWindow = windows[el.target] || windows._self;
        targetWindow.location.href = el.href;
      };

      options.callback = makeFailSafe(pageMove);
    }

    window.ga('send', {
      hitType      : options.type || 'event',
      eventCategory: options.category || '',
      eventAction  : options.action || 'click',
      eventLabel   : options.label,
      eventValue   : options.value,
      hitCallback  : options.callback,
    });
  };

  if (el[KEY]) {
    el.removeEventListener('click', el[KEY].handler);
  }
  el.addEventListener('click', handler);
  el[KEY] = { options, handler };
};

export default {
  inserted: setup,
  bind    : setup,
  update  : setup,
  unbind(el) {
    if (el[KEY]) {
      el.removeEventListener('click', el[KEY].handler);
      el[KEY] = null;
    }
  },
};
